import * as React from 'react';

import { UseFormReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { ValidatorAccountFormSchemaValues } from 'src/features/validatorAccounts/utils/formSchema';
import InputFormField from 'src/registry/components/forms/InputFormField';
import TextareaFormField from 'src/registry/components/forms/TextareaFormField';
import { Form } from 'src/registry/ui/Form';
import { generalMessages } from 'src/registry/utils/messages';
import { validatorAccountsMessages } from 'src/features/validatorAccounts/utils/messages';
import SearchSelectFormField from 'src/registry/components/forms/SearchSelectFormField';
import { useListUsersForValidatorAccounts } from 'src/features/validatorAccounts/api/useListUsersForValidatorAccounts';
import { useParking } from 'src/providers/ParkingProvider';

type ValidatorAccountFormProps = {
    form: UseFormReturn<ValidatorAccountFormSchemaValues>;
    onSubmit: (values: ValidatorAccountFormSchemaValues) => void;
};

function ValidatorAccountForm({ onSubmit, form }: ValidatorAccountFormProps) {
    const { formatMessage } = useIntl();
    const { parkingId } = useParking();

    const [searchUser, setSearchUser] = React.useState<string>('');

    const { data: usersList } = useListUsersForValidatorAccounts({
        parkingId,
        search: searchUser,
    });

    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)} variant="dialog">
            <InputFormField<ValidatorAccountFormSchemaValues>
                form={form}
                name="name"
                label={formatMessage(generalMessages.name)}
            />

            <TextareaFormField<ValidatorAccountFormSchemaValues>
                form={form}
                name="description"
                required={false}
                label={formatMessage(generalMessages.description)}
            />
            <SearchSelectFormField
                name="users"
                control={form.control}
                label={formatMessage(validatorAccountsMessages.users)}
                items={usersList?.results ?? []}
                clearable
                required={false}
                placeholder={`${formatMessage(validatorAccountsMessages.user)}...`}
                searchPlaceholder={formatMessage(validatorAccountsMessages.searchUser)}
                emptyTitle={formatMessage(validatorAccountsMessages.noUser)}
                emptyDescription={formatMessage(validatorAccountsMessages.noUserFound)}
                getItemValue={(user) => user.id}
                getItemLabel={(user) => user.name}
                getItemKeywords={(user) => [user.name]}
                loadOptions={setSearchUser}
                isMultiSelect={true}
            />
        </Form>
    );
}

export default ValidatorAccountForm;
